<template>
  <v-navigation-drawer
    permanent
    v-model="show"
    class="noto d-print-none"
    app
    clipped
    mobile-breakpoint="960"
    :mini-variant.sync="collapse">
    <v-row class="fill-height" no-gutters>
      <v-col
        v-if="isLoading"
        class="d-flex justify-space-between flex-column">
        <v-flex>
          <v-skeleton-loader
            v-for="index in 6"
            :key="`loader-${index}`"
            class="mx-auto"
            type="list-item"
          />
        </v-flex>
      </v-col>
      <v-col v-else class="d-flex justify-space-between flex-column">
        <v-flex>
          <div class="d-md-none">
            <div class="d-flex justify-end pa-3">
              <v-icon
                color="primary"
                @click="toggleSidebar">
                mdi-close
              </v-icon>
            </div>
            <v-divider />
            <div>
              <RestaurantSelector />
            </div>
          </div>
          <v-divider />
          <v-list
            dense
            :nav="false"
            :subheader="true"
          >
            <template v-for="(section, index) in sections">
              <template v-if="section">
                <v-subheader :key="index">
                  {{ section.subheader }}
                </v-subheader>
                <template v-for="(item, itemIndex) in section.items">
                  <template v-if="item">
                    <v-list-item
                      v-if="item.href" :key="`module-${index}-${itemIndex}`" :to="item.href" link>
                      <v-list-item-icon class="mr-4">
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>
                          {{ translate(item.title) }}

                        </v-list-item-title>
                      </v-list-item-content>
                      <v-chip
                        v-if="item.quantity"
                        small
                        color="primary"
                        text-color="white">
                        <span>{{ item.quantity }}</span>
                      </v-chip>
                    </v-list-item>

                    <v-list-group
                      v-else
                      :key="`module-${index}-${itemIndex}`"
                      no-action
                      flat
                      :value="setActiveMenu(item.children)">
                      <template v-slot:activator>
                        <v-list-item-icon class="mr-4">
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ translate(item.title) }}</v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <template
                        v-for="(item, i) in item.children"
                      >
                        <v-list-item
                          v-if="item"
                          :key="`link-${index}-${itemIndex}-${i}`"
                          class="pl-9"
                          :input-value="setActiveLink(item)"
                          @click="goTo(item.href, item.area)"
                        >
                          <v-list-item-icon
                            v-if="item.icon"
                            class="mr-4">
                            <v-icon>{{ item.icon }}</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title>{{ translate(item.title) }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list-group>
                  </template>
                </template>
                <v-divider :key="`divider-${section.subheader}`"/>
              </template>
            </template>
          </v-list>
        </v-flex>
        <div class="d-none d-md-block">
          <v-btn
            block
            text
            tile
            @click.stop="collapse = !collapse">
            <v-icon
              v-if="collapse"
              small
              color="black">
              mdi-arrow-collapse-right
            </v-icon>
            <v-icon
              v-else
              small
              color="black">
              mdi-arrow-collapse-left
            </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

  </v-navigation-drawer>
</template>

<script>
import RestaurantSelector from '@/components/elements/RestaurantSelector'
import { mapGetters } from 'vuex'

export default {
  name: 'SideBar',
  components: {
    RestaurantSelector
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      collapse: false,
      isValid: false,
      dialog: false,
      show: false,
      form: { name: '' }
    }
  },
  watch: {
    show (isOpen) {
      this.show = isOpen
      this.$emit('toggle', isOpen)
    },
    isOpen (isOpen) {
      this.show = isOpen
      this.$emit('toggle', isOpen)
    },
    role (role) {
      if (['provider', 'provider-buyer', 'provider-manager'].includes(role)) {
        this.$store.dispatch('getOrdersQuantity')
      }
    }
  },
  mounted () {
    this.show = !this.$isMobile
    if (['provider', 'provider-buyer', 'provider-manager'].includes(this.$is())) {
      this.$store.dispatch('getOrdersQuantity')
    }
  },
  computed: {
    ...mapGetters(['allowedAreas']),
    ...mapGetters({
      isLive: 'currentRestaurant/isLive'
    }),
    ordersQuantity () {
      return this.$store.state.ordersQuantity
    },
    role () {
      return this.$is()
    },
    isLoading () {
      return this.$store.state.isLoading
    },
    thisRoute () {
      return this.$route
    },
    activeRestaurant () {
      return this.$store.state.currentRestaurant.data || {}
    },
    activeArea () {
      return this.$store.state.area || {}
    },
    areas () {
      return this.$store.state.currentRestaurant.areas.data || []
    },
    user () {
      return this.$store.state.login.user || {}
    },
    permissions () {
      return this.$store.state.login.permissions
    },
    isUserProvider () {
      return this.$store.state.userProvider
    },
    sections () {
      const menus = [
        {
          subheader: 'Módulos',
          items: [
            {
              title: 'menu.purchase.inbox',
              icon: 'mdi-inbox-arrow-down',
              quantity: (this.ordersQuantity.find(orderQuantity => orderQuantity.status === 'sentNotRead') || {}).number || 0,
              href: `/inbox`,
              roles: ['provider', 'provider-buyer', 'provider-manager'],
              permission: 'purchase-orders'
            },
            {
              title: 'menu.purchase.toConfirm',
              icon: 'mdi-check-circle',
              quantity: (this.ordersQuantity.find(orderQuantity => orderQuantity.status === 'sentIsRead') || {}).number || 0,
              href: `/to-confirm`,
              roles: ['provider', 'provider-buyer', 'provider-manager'],
              permission: 'purchase-orders'
            },
            {
              title: 'menu.purchase.toInvoice',
              quantity: (this.ordersQuantity.find(orderQuantity => orderQuantity.status === 'confirmed') || {}).number || 0,
              icon: 'mdi-script-text',
              href: `/to-invoice`,
              roles: ['provider', 'provider-buyer', 'provider-manager'],
              permission: 'purchase-orders'
            },
            {
              title: 'menu.purchase.toDeliver',
              quantity: (this.ordersQuantity.find(orderQuantity => orderQuantity.status === 'invoiced') || {}).number || 0,
              icon: 'mdi-truck-delivery',
              href: `/to-deliver`,
              roles: ['provider', 'provider-buyer', 'provider-manager'],
              permission: 'purchase-orders'
            },
            {
              title: 'menu.purchase.title',
              icon: 'mdi-receipt',
              href: `/provider-orders`,
              roles: ['provider', 'provider-buyer', 'provider-manager'],
              permission: 'purchase-orders'
            },
            {
              title: 'orders.shoppingList',
              icon: 'mdi-view-list',
              href: `/purchase-orders-products`,
              roles: ['provider', 'provider-buyer', 'provider-manager']
            },
            {
              title: 'menu.catalog',
              icon: 'mdi-book-open',
              href: '/products',
              roles: ['provider', 'provider-manager'],
              permission: 'products-catalog'
            },
            {
              title: 'menu.deposits',
              icon: 'mdi-cash-usd',
              href: '/provider-deposits',
              roles: ['provider'],
              permission: 'my-deposits'
            },
            {
              title: 'menu.taxes',
              icon: 'mdi-scale-balance',
              href: '/provider-taxes',
              roles: ['provider'],
              permission: 'my-taxes'
            },
            {
              title: 'menu.issues',
              icon: 'mdi-alert-circle-outline',
              href: '/issues',
              roles: ['provider']
            }
            // {
            //   title: 'menu.clients',
            //   icon: 'mdi-account',
            //   href: `/customer-credit`,
            //   roles: ['provider', 'provider-buyer', 'provider-manager']
            // }
          ]
        }
      ]

      menus.push({
        subheader: 'Configuración',
        items: [{
          title: 'menu.settings.title',
          icon: 'mdi-settings',
          permission: 'settings',
          children: [
            {
              title: 'menu.settings.areas',
              href: { name: 'RestaurantAreas', params: { id: this.activeRestaurant._id } },
              roles: ['manager']
            },
            {
              title: 'menu.settings.sections',
              href: { name: 'RestaurantSections', params: { id: this.activeRestaurant._id } },
              roles: ['manager']
            },
            {
              title: 'menu.settings.users',
              href: { name: 'RestaurantUsers', params: { id: this.activeRestaurant._id } },
              roles: ['manager']
            },
            {
              title: 'menu.settings.restaurant',
              href: { name: 'RestaurantSettings', params: { id: this.activeRestaurant._id } },
              roles: ['manager']
            },
            {
              title: 'menu.settings.balance',
              href: { name: 'RestaurantBalance', params: { id: this.activeRestaurant._id } },
              roles: ['manager']
            },
            {
              title: 'menu.provider_users',
              href: { name: 'ProviderUsers' },
              roles: ['provider']
            },
            {
              title: 'menu.settings.taxInformation',
              href: { name: 'ProviderSettings' },
              roles: ['provider']
            },
            {
              title: 'menu.settings.bankInformation',
              href: { name: 'ProviderBank' },
              roles: ['provider']
            },
            {
              title: 'menu.settings.notification',
              href: { name: 'ProviderNotification' },
              roles: ['provider']
            },
            {
              title: 'menu.settings.delivery',
              href: { name: 'ProviderDelivery' },
              roles: ['provider']
            }
          ]
        }]
      })

      if (this.isLive) {
        menus[0].items.push({
          title: 'menu.management.title',
          icon: 'mdi-finance',
          permission: 'my-management',
          children: [
            {
              title: 'menu.purchase.balance',
              href: '/balance',
              roles: ['manager']
            },
            {
              title: 'menu.management.purchases',
              href: '/purchase-made',
              roles: ['manager']
            },
            {
              title: 'menu.management.movements',
              href: '/movements',
              roles: ['manager']
            },
            {
              title: 'menu.management.commission',
              href: '/commission-orders',
              roles: ['manager']
            },
            {
              title: 'Ventas',
              href: '/sales',
              roles: ['manager', 'buyer']
            },
            {
              title: 'Compras',
              href: '/accounting',
              roles: ['manager', 'buyer', 'financier']
            }
          ]
        })
        menus.push(
          {
            subheader: 'Gestión',
            items: [
              {
                title: 'menu.income.title',
                icon: 'mdi-trending-up',
                href: '/income'
              },
              {
                title: 'menu.expense.title',
                icon: 'mdi-trending-down',
                href: '/expense'
              },
              {
                title: 'menu.movements.title',
                icon: 'mdi-repeat',
                href: '/management-movements'
              }
            ]
          },
          {
            subheader: 'Administración',
            items: [
              {
                title: 'menu.management.contability',
                href: '/management',
                icon: 'mdi-chart-line'
              },
              {
                title: 'menu.management.reports',
                href: '/reports',
                icon: 'mdi-chart-bar'
              }
            ]
          }
        )

        menus[1].items.find(x => x.title === 'menu.settings.title').children.push(
          // {
          //   title: 'menu.settings.providers',
          //   href: { name: 'RestaurantProviders', params: { id: this.activeRestaurant._id } },
          //   roles: ['manager']
          // },
          {
            title: 'menu.settings.pointSale',
            href: { name: 'RestaurantPointSale', params: { id: this.activeRestaurant._id } },
            roles: ['manager']
          }
        )
        menus[1].items[0].children.push(
          {
            title: 'Finanzas',
            href: { name: 'Finances' },
            roles: ['manager']
          }
        )
      }

      const areas = this.allowedAreas
        .map(area => {
          const areaSections = [
            { title: 'menu.kitchen.title', href: `/recipes-book`, area: area, roles: ['manager', 'chef'] }
          ]

          if (this.isLive) {
            areaSections.push({ title: 'menu.purchase.list', href: `/purchase`, area: area, roles: ['manager', 'stockmanager', 'buyer'], permission: 'purchase-orders' })
            areaSections.push({ title: 'menu.inventory.title', href: `/warehouse`, area: area, roles: ['manager', 'stockmanager', 'buyer', 'chef'] })
          }

          return {
            title: area.name.charAt(0).toUpperCase() + area.name.toLowerCase().slice(1),
            icon: 'mdi-notebook',
            children: areaSections
          }
        })

      menus[0].items.unshift(
        ...areas,
        {
          title: 'menu.menu.title',
          icon: 'mdi-silverware',
          href: '/menu/sheet',
          roles: ['manager', 'buyer', 'chef']
        }
      )

      return menus.filter(menu => {
        menu.items = menu.items.filter(item => {
          if (item.children) {
            item.children = item.children.filter(child => {
              if (child.permission) {
                return this.permissions[child.permission].visible
              }
              return child.roles.includes(this.$is())
            })
            return item.children.length > 0
          }
          if (item.permission) {
            return menu.items.length > 0 && this.isUserProvider && this.permissions[item.permission].visible
          }
          if (item.roles) {
            return menu.items.length > 0 && item.roles.includes(this.$is())
          }
          return item
        })
        return menu.items.length > 0
      })
    }
  },
  methods: {
    setActiveLink (item) {
      if (item.area) {
        if (item.area.id === this.activeArea.id && this.thisRoute.matched.some(route => route.path === item.href)) {
          return true
        }
        return false
      }
      if (this.thisRoute.matched.some(route => route.path === item.href)) {
        return true
      }
      if (this.thisRoute.matched.some(route => route.name === item.href.name)) {
        return true
      }
      return false
    },
    setActiveMenu (children) {
      const active = children.some(item => {
        if (item.href.name) {
          return item.href.name === this.thisRoute.name
        }
        return item.area
          ? this.thisRoute.matched.some(route => route.path === item.href) && item.area.id === this.activeArea.id
          : this.thisRoute.matched.some(route => route.path === item.href)
      })
      return active
    },
    goTo (href, area) {
      if (area) {
        this.setArea(area)
      }
      this.$router.push(href)
    },
    collapseMenu () {
      this.collapse = !this.collapse
    },
    resetForm () {
      this.form.name = ''
    },
    closeDialog () {
      this.resetForm()
      this.dialog = false
    },
    toggleSidebar () {
      this.show = !this.show
    },
    setArea (area) {
      this.$store.commit('setArea', area)
    },
    translate (term) {
      const exp = new RegExp(/[A-Za-z]\.[A-Za-z]/)
      return exp.test(term)
        ? this.$t(term)
        : term
    }
  }
}
</script>

<style lang="scss">
.v-application {
  .v-list-group{
    &--active {
      .v-list-group__header {
        color: #01D28E !important;
      }
    }
  }

  .v-list-item {
    &--active {
      &::before {
        background-color: #01D28E !important;
      }

      .v-icon {
        color: inherit !important;
      }
    }
    .theme--light.v-icon {
      color: black;
    }
  }

}
</style>
